"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utilities_1 = require("./global/utilities");
const publications = Array.from(document.querySelectorAll('[data-gs1-publication]'));
const publicationPanels = Array.from(document.querySelectorAll('[data-gs1-publication-panel]'));
if (publications) {
    publications.forEach((publication) => {
        publication.addEventListener("click", (event) => {
            event.preventDefault();
            const el = event.target;
            const closest = el.closest('div').querySelector('[data-gs1-publication-panel]');
            (closest && closest.classList.contains('hidden')) ? closest.classList.remove('hidden') : closest.classList.add('hidden');
            const documentBlocker = document.createElement('div');
            documentBlocker.remove();
            documentBlocker.classList.add('modal__blocker');
            document.querySelector('body').appendChild(documentBlocker);
            const detailPageLink = el.getAttribute('data-gs1-publication-link');
            try {
                (0, utilities_1.fetchPage)(detailPageLink)
                    .then((data) => {
                    let getElements = new DOMParser();
                    //@ts-ignore
                    let element = getElements.parseFromString(data, 'text/html');
                    let publicationContent = element.querySelector('.tx-gs1publications-pi-detail');
                    closest.children[0].innerHTML = publicationContent.innerHTML;
                }).catch(error => console.error(error));
            }
            catch (error) {
                console.error(`Failed to fetch: ${detailPageLink}`, error);
            }
        });
    });
}
